(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  const initAccordion = (root) => {
    root.querySelectorAll('details.amure-faqs__item').forEach((item) => {
      if (item.dataset.bound === 'true') return;
      item.dataset.bound = 'true';

      const summary = item.querySelector('.amure-faqs__summary');
      const sync = () => {
        if (summary) summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
      };
      sync();

      item.addEventListener('toggle', () => {
        sync();
        if (!item.open) return;
        const group = item.closest('[data-faq-group]');
        const scope = group || root;
        scope.querySelectorAll('details.amure-faqs__item[open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  };

  const setActiveCategory = (root, category) => {
    if (!category) return;

    root.querySelectorAll('[data-faq-nav]').forEach((tab) => {
      const active = tab.getAttribute('data-faq-target') === category;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-faq-group]').forEach((group) => {
      const match = group.getAttribute('data-faq-category') === category;
      if (DESKTOP_MQ.matches) {
        if (match) {
          group.hidden = false;
          group.classList.add('is-active');
        } else {
          group.hidden = true;
          group.classList.remove('is-active');
        }
      } else {
        group.hidden = false;
        group.classList.toggle('is-active', match);
      }
    });
  };

  const syncLayoutMode = (root) => {
    const activeTab = root.querySelector('[data-faq-nav].is-active');
    const fallback = root.querySelector('[data-faq-nav]');
    const category =
      (activeTab && activeTab.getAttribute('data-faq-target')) ||
      (fallback && fallback.getAttribute('data-faq-target'));

    if (!DESKTOP_MQ.matches) {
      root.querySelectorAll('[data-faq-group]').forEach((group) => {
        group.hidden = false;
      });
      return;
    }

    setActiveCategory(root, category);
  };

  const initNav = (root) => {
    root.querySelectorAll('[data-faq-nav]').forEach((tab) => {
      if (tab.dataset.bound === 'true') return;
      tab.dataset.bound = 'true';
      tab.addEventListener('click', () => {
        const category = tab.getAttribute('data-faq-target');
        setActiveCategory(root, category);
      });
    });
  };

  const init = (root) => {
    initAccordion(root);
    initNav(root);
    syncLayoutMode(root);
  };

  const boot = () => {
    document.querySelectorAll('[data-amure-faqs]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (typeof DESKTOP_MQ.addEventListener === 'function') {
    DESKTOP_MQ.addEventListener('change', () => {
      document.querySelectorAll('[data-amure-faqs]').forEach(syncLayoutMode);
    });
  } else if (typeof DESKTOP_MQ.addListener === 'function') {
    DESKTOP_MQ.addListener(() => {
      document.querySelectorAll('[data-amure-faqs]').forEach(syncLayoutMode);
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-amure-faqs]');
    if (root) init(root);
  });
})();
